import { Box } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectUser } from '../../reducers/auth/authSlice';
import { useDispatch } from 'react-redux';
import { getMessages, markMessagesSeen } from '../../reducers/help-center/helpCenterSlice';
import socket from '../../utils/socket';
import { JOIN_HELP_CENTER, LEAVES_HELP_ROOM_ID, SEND_MESSAGE_TO_HELP_CENTER } from '../../utils/socket-events';
import HelpCenterChatBoxFooter from './HelpCenterChatBoxFooter';
import HelpCenterMessage from './HelpCenterMessage';
import Loader from '../common/Loader/Loader';

export default function HelpCenterChatBox() {

  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const currentLoginUser = useSelector(selectUser);
  const dispatch = useDispatch();
  const containerRef = useRef(null);

  useEffect(() =>{
    const fetchMssages = async() => {
      try{
        setIsLoading(true);

        const response = await dispatch(getMessages(currentLoginUser._id));

        socket.emit(JOIN_HELP_CENTER, LEAVES_HELP_ROOM_ID);

        if(response && response.messages.length > 0){
          setMessages(response.messages);
          scrollToBottom();
          markMessagesAsSeen();
        }
      }catch(err){
        console.error(err);
      }
      setIsLoading(false);
    };
    
    fetchMssages();
  },[dispatch]);

  useEffect(() => {
    socket.on(SEND_MESSAGE_TO_HELP_CENTER, ({ message, user }) => {
      if(currentLoginUser._id === user._id){
        setMessages(prev => [...prev, message]);
        scrollToBottom();
      }
    });

    return () => {
      socket.off(SEND_MESSAGE_TO_HELP_CENTER);
    };
  },[socket]);

  const markMessagesAsSeen = async() => {
    try{
      await dispatch(markMessagesSeen(currentLoginUser._id,
        getUnreadMessages().map(message => message._id))
      );
    }catch(err){
      console.error(err);
    }
  };

  const getUnreadMessages = () => {
    return messages.filter(message => message.sender !== currentLoginUser._id && !message.seen);
  };

  const scrollToBottom = () => {
    if(!containerRef.current) return;
    setTimeout(() => {
      containerRef.current.style.scrollBehavior = 'smooth';
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    },300);
  };

  if(isLoading){
    return <Loader />;
  }

  return (
    <>
      
      <Box sx={{ height: 'calc(100vh - 180px)' }} m={1.5} overflow={'auto'} ref={containerRef}>
        {
          (messages || []).map((message,i) =>  <HelpCenterMessage 
            key={message._id}
            message={message}
            chat={{ messages: messages, user: currentLoginUser }}
            index={i}
          />)
        }
      </Box>

      <Box mx={1.5}>
        <HelpCenterChatBoxFooter user={currentLoginUser} sender={currentLoginUser._id} />
      </Box>

    </>
  );
}
